import ResetPassword from '../../templates/views/Account/ResetPassword';

export default {
  path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    props: true,
    meta: {
      title: 'Reset Password',
    },
};
